import useNotificationStore from './store';
import { FC, useEffect } from 'react';
import { toast } from 'sonner';

export const Notifications: FC = () => {
  const { isOpen, message, type, close } = useNotificationStore();

  useEffect(() => {
    if (isOpen) {
      if (type === 'warning') {
        toast.warning(message);
      } else {
        toast('', { description: message });
      }
      setTimeout(close, 1000);
    }
  }, [isOpen]);

  return <span></span>;
};
